<template>
  <PublicationsWrapper groupType="collection" groupId="2212" />
</template>
<script>
import PublicationsWrapper from "@/components/publications/PublicationsWrapper";
export default {
  components: {
    PublicationsWrapper
  }
};
</script>
